var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.folders.length > 0
    ? _c(
        "div",
        [
          _c(
            "ul",
            {
              staticClass: "accordion",
              attrs: {
                id: "project-docs-accordion",
                "data-accordion": "",
                "data-deep-link": "true",
                "data-allow-all-closed": "true",
                "data-multi-expand": "true",
                "data-update-history": "true",
                "data-deep-link-smudge": "500",
              },
            },
            _vm._l(_vm.folders, function (folder, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "accordion-item",
                  attrs: { "data-accordion-item": "" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "accordion-title",
                      attrs: { href: "#project-docs-accordion-" + index },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "medium-6 column title-label" },
                          [
                            _c("div", { staticClass: "title-index" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                            _c("span", { staticClass: "folder-title" }, [
                              _vm._v(_vm._s(folder.folderType)),
                            ]),
                            _vm._v(" "),
                            _vm.isPicView && !_vm.isAppr(folder)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "project-docs-accordion-menu",
                                  },
                                  [
                                    _c(
                                      "dotted-dropdown",
                                      {
                                        attrs: {
                                          id:
                                            "project-docs-dotted-dropdown-" +
                                            index,
                                        },
                                      },
                                      [
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                id:
                                                  "project-docs-dotted-dropdown-delete-" +
                                                  index,
                                              },
                                              on: {
                                                click: function () {
                                                  return _vm.deleteFolder(
                                                    folder.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("action.delete")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isDraft(folder)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "medium-5 column uppercase-bold doc-status",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "doc-status-rect",
                                    class: {
                                      "rejected-status": !_vm.isAppr(folder),
                                      "accepted-status": _vm.isAppr(folder),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.isAppr(folder)
                                            ? _vm.$t("accepted")
                                            : _vm.$t("rejected")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "project-docs-accordion-info" }, [
                    _c("div", { staticClass: "project-docs-accordion-desc" }, [
                      _vm.allowChangeName[index]
                        ? _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: folder.description,
                                expression: "folder.description",
                              },
                              { name: "autosize", rawName: "v-autosize" },
                            ],
                            staticClass: "autosize",
                            attrs: {
                              id:
                                "project-docs-accordion-doctype-desc-" + index,
                              type: "text",
                              maxlength: "255",
                              autofocus: "",
                            },
                            domProps: { value: folder.description },
                            on: {
                              focusout: function () {
                                return _vm.updateDescription(folder, index)
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  folder,
                                  "description",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("div", [
                            _c(
                              "pre",
                              {
                                on: {
                                  dblclick: function () {
                                    return _vm.dblClickEdit(index, folder)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "emphasis" }, [
                                  _vm._v(
                                    _vm._s(
                                      folder.description ||
                                        (_vm.isPicViewLike &&
                                        !_vm.isAppr(folder)
                                          ? _vm.$t("project.docs.fillDescHint")
                                          : "")
                                    )
                                  ),
                                ]),
                                _vm.isPicViewLike && !_vm.isAppr(folder)
                                  ? _c("a", {
                                      staticClass: "fa fa-pencil icon",
                                      attrs: {
                                        id: "settings-engineers-security-group-detail-name-edit",
                                      },
                                      on: {
                                        click: function () {
                                          return _vm.Vue.set(
                                            _vm.allowChangeName,
                                            index,
                                            true
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v("\n            "),
                              ]
                            ),
                          ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "accordion-content",
                      attrs: {
                        id: "project-docs-accordion-" + index,
                        "data-tab-content": "",
                      },
                    },
                    [
                      _vm.isOnlyContractor &&
                      !_vm.isAppr(folder) &&
                      _vm.isProjectActive
                        ? _c("HkldDropzone", {
                            attrs: {
                              sourceId: folder.id,
                              action: _vm.getCreateDocAction(),
                              metaData: { uploadOnTop: true },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "EditAttachments",
                        {
                          attrs: {
                            sourceId: folder.id,
                            canEdit:
                              _vm.isOnlyContractor && !_vm.isAppr(folder),
                            canDelete:
                              _vm.isOnlyContractor || _vm.isPicViewLike,
                            canDownloadAll: _vm.isPicViewLike,
                            showAllDeleteBtn: false,
                            deleteFileCb: _vm.deleteFile,
                            uploadOnTop: true,
                            showDeleteBtnFunc: _vm.showDeleteBtnFunc(folder),
                            zipName:
                              _vm.currentProject.number +
                              "_Vendor_documents.zip",
                            action: _vm.getDeleteDocAction(),
                          },
                        },
                        [
                          _vm.isPicView && !_vm.isAppr(folder)
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-right clearfix",
                                  attrs: { slot: "buttons" },
                                  slot: "buttons",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn--darkblue tender-sticky-button",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function () {
                                          return _vm.rejectFolder(folder.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("action.reject")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn--orange tender-sticky-button",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function () {
                                          return _vm.approveFolder(folder.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("action.accept")) +
                                          " & " +
                                          _vm._s(_vm.$t("action.lock"))
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                folder.rejectHistory &&
                                folder.rejectHistory.length > 0,
                              expression:
                                "folder.rejectHistory && folder.rejectHistory.length > 0",
                            },
                          ],
                          staticClass: "clearfix action-history",
                        },
                        [
                          _c("div", [
                            _c("label", [_vm._v(_vm._s(_vm.$t("history")))]),
                          ]),
                          _vm._v(" "),
                          _vm._l(folder.rejectHistory, function (history, i) {
                            return _c("reject-history", {
                              key: i,
                              class: { "odd-row": i % 2 },
                              attrs: {
                                item: history,
                                isContractor: _vm.isContractor,
                                showRejectHeader: !i,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      folder.docs.length && !_vm.isAppr(folder)
                        ? _c(
                            "HKLViewLayout",
                            { attrs: { checkIsRepresentative: true } },
                            [
                              _c("ProjectRepRemarks", {
                                on: {
                                  review: function () {
                                    var args = [],
                                      len = arguments.length
                                    while (len--) args[len] = arguments[len]

                                    return _vm.review.apply(
                                      void 0,
                                      [folder].concat(args)
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("reject-modal", {
            ref: "rejectModal",
            attrs: { id: _vm.rejectModalId },
          }),
          _vm._v(" "),
          _c("approve-folder", { ref: "approveFolder" }),
          _vm._v(" "),
          _c("delete-folder", { ref: "deleteFolder" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }